import { HeaderSection } from 'components/common/general/CollectionManagementPanel/HeaderSection';
import styled from 'styled-components';

export const HeaderSectionStyled = styled(HeaderSection)`
  gap: 2rem;

  /* Align buttons to the left when they don't fill the full width 
     to prevent large empty gaps between them */
  justify-content: flex-start;

  @media (width <= 1458px) {
    justify-content: center;
    gap: 1rem;
  }
`;
